export const UNIQUEID_CATEGORY_PREFIX = 'UNIQUEID_CATEGORY_PREFIX';
